/**
 * Tracking configuration for page_view events sent to n8n.
 * Same webhook as the form submission — distinguish events by `event` field.
 */

export const TRACKING_WEBHOOK_URL =
  "https://n8n.srv1035791.hstgr.cloud/webhook/lovable-onboarding-step";

export const ACADEMY_REQUEST_WEBHOOK_URL =
  "https://n8n.srv1035791.hstgr.cloud/webhook/lovable-academy-request";

export const TOTAL_TRACKED_STEPS = 9;

export type TrackedStep = {
  step: string;
  stepLabel: string;
  stepIndex: number;
};

export const TRACKED_STEPS = {
  videoIntro: { step: "video-intro", stepLabel: "Video Intro", stepIndex: 0 },
  form: { step: "form", stepLabel: "Form multi-step", stepIndex: 1 },
  videoStep6: { step: "video-step-6", stepLabel: "Consulenza gratuita + bonus", stepIndex: 2 },
  community: { step: "community", stepLabel: "Community", stepIndex: 3 },
  videoStep1: { step: "video-step-1", stepLabel: "Caricamento materiale", stepIndex: 4 },
  videoStep2: { step: "video-step-2", stepLabel: "Responsabilità e doveri", stepIndex: 5 },
  videoStep3: { step: "video-step-3", stepLabel: "Come confermare gli appuntamenti telefonici", stepIndex: 6 },
  videoStep4: { step: "video-step-4", stepLabel: "Gestione casi critici", stepIndex: 7 },
  videoStep5: { step: "video-step-5", stepLabel: "Aspettative", stepIndex: 8 },
  thankYou: { step: "thank-you", stepLabel: "Grazie", stepIndex: 9 },
} as const satisfies Record<string, TrackedStep>;
